/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=7b462fc2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7b462fc2&lang=css"

import exportComponent from "/root/workspace/njyx-frontend-pc_5kTN/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__